import React from "react";
import { Chip } from "@material-tailwind/react";

export const Coaches = ({ tagline, heading, description, teamMembers }) => {
    return (
        <section className="px-[5%] py-12">
            <div className="container">
                <div className="mx-auto mb-10 max-w-lg text-center md:mb-18 lg:mb-15">
                    <div className="d-flex justify-content-center mt-2 mb-2">
                        <Chip className="custom-chip-two" color={"red"} value={tagline} />
                    </div>
                    <h2 className="mb-3 text-5xl font-bold md:text-7xl lg:text-8xl">
                        {heading}
                    </h2>
                    <p className="md:text-md">{description}</p>
                </div>

                <div className="coach-info grid grid-cols-1 items-start justify-center gap-x-8 gap-y-12 md:grid-cols-2 md:gap-y-16 lg:grid-cols-4">
                    {teamMembers.map((member, index) => (
                        <div
                            className="coach-card flex flex-col items-stretch text-center"
                            key={index}
                        >
                            <div className="relative mb-4 size-full overflow-hidden md:mb-6 md:pt-[100%]">
                                <img
                                    src={`/fsc-images/coaches/${member.imageUrl}`}
                                    alt={member.name}
                                    className="md:absolute inset-0 sm:h-[100%] sm:w-[75%] md:size-full object-cover sm:mx-auto"
                                />
                            </div>
                            <div className="mb-3 md:mb-4">
                                <h5 className="text-md font-semibold md:text-lg">{member.name}</h5>
                                {member.jobTitle && (
                                    <div className="d-flex justify-content-center mt-1">
                                        <Chip
                                            className="custom-chip"
                                            size="sm"
                                            color="black"
                                            variant="outlined"
                                            value={member.jobTitle}
                                        />
                                    </div>
                                )}
                            </div>

                            {member.descriptionHtml && (
                                <div
                                    className="coach-description text-left"
                                    dangerouslySetInnerHTML={{ __html: member.descriptionHtml }}
                                />
                            )}

                            {member.email && (
                                <p className="coach-email text-sm mt-2">{member.email}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

Coaches.displayName = "Coaches";
